import { useState } from 'react';
import { createContainer } from 'unstated-next';
import {
  Providers as ProvidersContract,
  Utils,
} from '@sparrow-marketing/contracts';

export type ProviderType =
  | 'facebook'
  | 'instagram'
  | 'twitter'
  | 'linkedin'
  | 'youtube';

export interface PageType extends ProvidersContract.Accounts.IAccount<any> {
  service: string;
  id: string;
  subAccount?: boolean;
  subAccounts?: any[];
}

export type PageStateType = {
  isPagesPopulated: boolean;
  pages: Utils.ApiModel<PageType>[];
};

export type PageHookType = {
  state: PageStateType;
  updatePages: (pages: PageType[]) => void;
  resetPageState: () => void;
  updatePage: (updatedPage: PageType) => void;
  deletePage: (id: string) => void;
};

const initialState: PageStateType = {
  isPagesPopulated: false,
  pages: [],
};

export function usePagesHook(
  customInitialState?: Partial<PageStateType>
): PageHookType {
  const [state, updatePageData] = useState({
    ...initialState,
    ...(customInitialState || {}),
  });

  const updatePages = (pages: PageType[]): void => {
    updatePageData({
      ...state,
      isPagesPopulated: true,
      pages,
    });
  };

  const resetPageState = (): void =>
    updatePageData({
      ...initialState,
    });

  const updatePage = (updatedPage: any): void => {
    updatePageData({
      ...state,
      pages: state.pages.map((page: any) =>
        updatedPage.id === page.id ? updatedPage : page
      ),
    });
  };

  const deletePage = (id: string): void => {
    updatePageData({
      ...state,
      pages: state.pages.filter((page: any) => page.id !== id),
    });
  };

  return { state, updatePages, resetPageState, updatePage, deletePage };
}

const PagesContainer = createContainer(usePagesHook);

export default PagesContainer;
